import { call, put, select } from 'redux-saga/effects';
import { addItemRequest, getItemsRequest, updateItemRequest } from '../../spItems/api';
import { VPORequirementsConditionsListName } from 'src/api/config';
import { getReportFactory, getReportFactorySuccess, getReportSummarySuccess } from '../actions';
import { getDefaultSaga } from './getDefaultSaga';
import { updateDefaultSaga } from 'src/modules/spItems/sagas/updateDefaultSaga';
import { addDefaultSaga } from 'src/modules/spItems/sagas/addDefaultSaga';
import { actionsVPO, VPOInconsistences } from 'src/pages/DashboardPage/vpo/api/vpo.config';
import { ContentTypeIdColumn, ContentTypeIdDirectory, ContentTypeIdGroupRequirement, ContentTypeIdRequirement } from '../api/config';

export function* getReportSummarySaga({ payload }: any): Generator<any, void, any> {
  try {
    if (payload) {
      
      const { 
        GroupID,
        GroupTitle,
        FactoryID,
        Month,
        Year 
      } = payload;

      console.log('payload', payload);

      let GroupIDArray: any = [];
      let GroupIDArrayPaths: any = [];

      if( GroupTitle == 'BOP'){
        GroupIDArray = [24, 31, 501, 841, 2022, 2591, 3940, 5290];
        GroupIDArrayPaths = [
          '22_.000/24_.000',
          '30_.000/31_.000',
          '499_.000/501_.000',
          '500_.000/841_.000',
          '2021_.000/2022_.000',
          '2590_.000/2591_.000',
          '3938_.000/5290_.000',
        ];
      }
      if( GroupTitle == 'SOP'){
        GroupIDArray = [27];
        GroupIDArrayPaths = [
          '22_.000/27_.000',
        ];
      }
      if( GroupTitle == 'VOP'){
        GroupIDArray = [1279, 1566, 502, 842, 2023, 2592, 3939];
        GroupIDArrayPaths = [
          '22_.000/1279_.000',
          '30_.000/1566_.000',
          '499_.000/502_.000',
          '500_.000/842_.000',
          '2021_.000/2023_.000',
          '2590_.000/2592_.000',
          '3938_.000/3939_.000',
        ];
      }

      let response_requirements: unknown = null;
      let filters_requirements: any = {
        ContentTypeId: '^' + ContentTypeIdRequirement,
      };

      if(
        GroupTitle &&
        GroupTitle !== ''
      ){
        filters_requirements.FileRef = GroupIDArray.map((ID: any) => '*_.000/' + ID + '_.000');
      }

      console.log('filters_requirements', filters_requirements);

      response_requirements = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        filters: filters_requirements,
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      });

      let response_directory: unknown = null;
      let filters_group_directory: any = {
        ContentTypeId: '^' + ContentTypeIdDirectory,
      };

      response_directory = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        filters: filters_group_directory,
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      });

      
      let response_group_requirements: unknown = null;
      let filters_group_requirements: any = {
        ContentTypeId: '^' + ContentTypeIdGroupRequirement,
      };

      if(FactoryID && FactoryID !== ''){
        filters_group_requirements.Factory = FactoryID;
      }

      if(
        GroupTitle &&
        GroupTitle !== ''
      ){
        filters_group_requirements.FileRef = GroupIDArray.map((ID: any) => '*_.000/' + ID + '_.000');
      }

      response_group_requirements = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        filters: filters_group_requirements,
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      });

      console.log('response_group_requirements', response_group_requirements);

      let response_columns: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOColumns',
        recursiveAll: true,
        filters: {
          ContentTypeId: '^' + ContentTypeIdColumn,
        },
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      });

      let response_questionary_all: unknown = yield call<any>(getDefaultSaga, {
        listName: 'VPOStatusQuestionnaire',
        filtersType: 'and',
        filters: {
          GroupTitle: ''+GroupTitle,
          FactoryID: ''+FactoryID,
          Month: ''+Month,
          Year: ''+Year
        },
      })

      let response_default_conditions: unknown = null;
      // let filters_default_conditions: any = {
      //   Condition: 'Lock',
      // };

      // if(
      //   GroupTitle &&
      //   GroupTitle !== ''
      // ){
      //   filters_default_conditions.FileRef = '*/' + GroupTitle;
      // }

      // response_default_conditions = yield call<any>(getDefaultSaga, {
      //   listName: 'VPODefaultRequirementConditions',
      //   recursiveAll: true,
      //   filtersType: 'and',
      //   filters: filters_default_conditions
      // });
      

      interface ResponseConditions {
        items: any[];
      }

      interface GroupRequirement {
        FileRef: string;
      }

      interface GroupRequirementsResponse {
        items: GroupRequirement[];
      }

      let response_conditions: ResponseConditions = {
        items: []
      };
      let filters_conditions: any = {};

      if(Month && Month !== ''){
        filters_conditions.Month = ''+Month;
      }
      if(Year && Year !== ''){
        filters_conditions.Year = ''+Year;
      }
      if(FactoryID && FactoryID !== ''){
        filters_conditions.FactoryID = ''+FactoryID;
      }

      function* fetchChunk(chunk: string[]): Generator<any, any[], any> {
        const response = yield call<any>(getDefaultSaga, {
          listName: VPORequirementsConditionsListName,
          filters: {
            ...filters_conditions,
            GroupRequirementFileRef: chunk
          },
          filtersType: "and",
        });

        return response?.items || [];
      }

      const groupRequirements = response_group_requirements as GroupRequirementsResponse;
      if(
        groupRequirements &&
        Array.isArray(groupRequirements.items) &&
        groupRequirements.items.length > 0
      ) {
        const fileRefs = groupRequirements.items.map((item: GroupRequirement) => item.FileRef);
        const chunkSize = 5;
        
        for (let i = 0; i < fileRefs.length; i += chunkSize) {
          const chunk = fileRefs.slice(i, i + chunkSize);
          const chunkResponse = yield fetchChunk(chunk);
          response_conditions.items = [...response_conditions.items, ...chunkResponse];
        }

        // Sort items by Modified date in descending order to get latest items first
        response_conditions.items.sort((a, b) => new Date(b.Modified).getTime() - new Date(a.Modified).getTime());

        // Create a Map to store unique items
        const uniqueItemsMap = new Map();

        // Process items to ensure uniqueness
        response_conditions.items.forEach(item => {
          // Create a unique key combining all required fields
          const uniqueKey = [
            item.Requirement.get_lookupId(),
            item.Month,
            item.Year,
            item.FactoryID,
            item.Subdivision?.get_lookupId()
          ].join('_');

          // Since we sorted by Modified date, the first occurrence will be the latest
          if (!uniqueItemsMap.has(uniqueKey)) {
            uniqueItemsMap.set(uniqueKey, item);
          }
        });

        // Convert Map back to array
        response_conditions.items = Array.from(uniqueItemsMap.values());
      }
      
      console.log('response_conditions', response_conditions);

      


      interface SubdivisionItem {
        Title: string;
        ID: number;
        VPOgroup: Array<{ get_lookupValue: () => string }>;
      }

      interface SubdivisionsResponse {
        items: SubdivisionItem[];
      }

      let response_subdivisions: SubdivisionsResponse = yield call<any>(getDefaultSaga, {
        listName: 'VPOsubdivision',
        rowLimit: 4000,
        filtersType: "or",
        recursiveAll: true,
        sortOrder: {
          name: 'SortNumber',
          desc: true
        }
      })

      const directions: unknown = yield select(state => state.vpo.elements.obj.Directory);

      let subdivisions: any = [];

      console.log('currentDirectory', GroupTitle, directions);

      // if(
      //   response_subdivisions &&
      //   response_subdivisions.items &&
      //   response_subdivisions.items.length > 0
      // ){
      //   response_subdivisions.items.map((item) => {
      //     subdivisions.push({
      //       Title: item.Title,
      //       ID: item.ID
      //     })
      //   })
      // }

      console.log('response_subdivisions', response_subdivisions);

      if(
        response_subdivisions &&
        response_subdivisions.items &&
        response_subdivisions.items.length > 0
      ){

        response_subdivisions.items.map((item) => {
          let state = false;
          item.VPOgroup.map((group) => {
            if(
              group &&
              group.get_lookupValue() == GroupTitle
            ){
              state = true;
            }
          })
          if(state){
            subdivisions.push({
              Title: item.Title,
              ID: item.ID
            })
          }
        })

        // let currentDirectory = response_subdivisions.items.filter(directory => directory.Title.indexOf(GroupTitle) >= 0);

        // console.log('currentDirectory', currentDirectory);
        // if(
        //   currentDirectory &&
        //   currentDirectory.length > 0 
        // ){
        //   currentDirectory[0].Subdivisions.map((item: any) => {
        //     subdivisions.push({
        //       Title: item.get_lookupValue(),
        //       ID: item.get_lookupId()
        //     })
        //   })
        // }
      }

      // console.log('subdivisions', subdivisions);

      // if(
      //   directories &&
      //   Object.values(directories) &&
      //   Object.values(directories).length > 0 &&
      //   filters &&
      //   filters.GroupRequirements
      // ){
      //   let currentDirectory = Object.values(directories).filter(directory => directory.FileRef.indexOf(filters.GroupRequirements.FileRef.replaceAll('*','')) >= 0);
      //   if(
      //     currentDirectory &&
      //     currentDirectory.length > 0 
      //   ){
      //     currentDirectory[0].Subdivisions.map((item: any) => {
      //       subdivisions.push({
      //         Title: item.get_lookupValue(),
      //         ID: item.get_lookupId()
      //       })
      //     })
      //   }
      // }

      console.log('response_questionary_all', response_questionary_all);

      yield put(
        getReportSummarySuccess({
          response_requirements,
          response_conditions,
          response_subdivisions,
          response_columns,
          response_group_requirements,
          response_default_conditions,
          response_directory,
          current_subdivisions: subdivisions,
          response_questionary_all: response_questionary_all,
          filters: {
            GroupID,
            FactoryID,
            Month,
            Year 
          }
        })
      );
    }
  } catch (error) {
    console.log(error);
  }
}
